import type { LegalPageProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

const LegalPage = (props: LegalPageProps) => {
  return <LazyComponent<LegalPageProps> name="LegalPage" {...props} />;
};

export default LegalPage;
